// Mirrors backend: core/workflow/incept/Ppsr/Enums/GrantorType.php
export enum GrantorType {
  Organisation = 'organisation',
  Individual = 'individual',
}

export const GRANTOR_TYPE_LABELS: Record<GrantorType, string> = {
  [GrantorType.Organisation]: 'Organisation',
  [GrantorType.Individual]: 'Individual',
};
